export const ITEM_PER_PAGES = 50;
export const CURRENT_PAGE = 1;
export const SORT_BY = 'createdAt';
export const SORT = 'desc';